import { request } from "@/lib/requests";

async function customCreate(props: unknown, fields: unknown) {
    const requestUrl = this.buildRequestUrl("create", props);

    const requestOptions = {};
    const contentType = this.getContentType("create");

    // Avoid setting the content type ourselves in case of formdata, so that
    // the browser can configure it and set the correct boundaries.
    if (contentType !== "multipart/form-data") {
        requestOptions["Content-Type"] = contentType;
    }

    const response = await request(
        requestUrl,
        {
            method: this.repository.actionPaths.create.method,
            body: this.getRequestBody(props, "create"),
        },
        requestOptions
    );

    if (![200, 201].includes(response.status)) {
        return response;
    }

    return this.handleResponse("create", response);
}

export const objects = { create: customCreate };
